const ProductGrid2by2 = ({children}) => {
    return (
        <div className="product-list" data-type="grid">
            {children}
        </div>
    );
};

export default ProductGrid2by2;